import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../layout/sidebar/Sidebar.jsx";
import Header from "../layout/header/Header.jsx";

const ProtectedRoutes = () => {
  const [toggleOpen, setToggleOpen] = useState(false);
  const isAuthenticated = true;
  return isAuthenticated ? (
    <div className="main-container">
      <div className="side-header">
        <div className="side-desk">
        <Sidebar toggleOpen={toggleOpen} setToggleOpen={setToggleOpen} />
        </div>
        <div className="header-width">
          <Header toggleOpen={toggleOpen} setToggleOpen={setToggleOpen} />
          <div className="children-container">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  ) : null(
    // <Navigate to={login} replace />
  );
};

export default ProtectedRoutes;
